var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order_list" },
    [
      _c(
        "div",
        { staticClass: "common_form_search" },
        [
          _c(
            "el-form",
            {
              ref: "searchForm",
              attrs: { inline: true, model: _vm.searchForm }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "订单号" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "请输入订单号", clearable: "" },
                    model: {
                      value: _vm.searchForm.orderNo,
                      callback: function($$v) {
                        _vm.$set(_vm.searchForm, "orderNo", $$v)
                      },
                      expression: "searchForm.orderNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入商品名称", clearable: "" },
                    model: {
                      value: _vm.searchForm.goodsName,
                      callback: function($$v) {
                        _vm.$set(_vm.searchForm, "goodsName", $$v)
                      },
                      expression: "searchForm.goodsName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "用户名" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入用户名", clearable: "" },
                    model: {
                      value: _vm.searchForm.receivingName,
                      callback: function($$v) {
                        _vm.$set(_vm.searchForm, "receivingName", $$v)
                      },
                      expression: "searchForm.receivingName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "手机号" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入手机号", clearable: "" },
                    model: {
                      value: _vm.searchForm.receivingMobile,
                      callback: function($$v) {
                        _vm.$set(_vm.searchForm, "receivingMobile", $$v)
                      },
                      expression: "searchForm.receivingMobile"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "风控姓名" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入风控姓名", clearable: "" },
                    model: {
                      value: _vm.searchForm.riskName,
                      callback: function($$v) {
                        _vm.$set(_vm.searchForm, "riskName", $$v)
                      },
                      expression: "searchForm.riskName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "风控手机号" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入风控手机号", clearable: "" },
                    model: {
                      value: _vm.searchForm.riskMobile,
                      callback: function($$v) {
                        _vm.$set(_vm.searchForm, "riskMobile", $$v)
                      },
                      expression: "searchForm.riskMobile"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "创建时间" } },
                [_c("my-date-picker", { ref: "myDatePicker" })],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "供应商" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入供应商", clearable: "" },
                    model: {
                      value: _vm.searchForm.shopName,
                      callback: function($$v) {
                        _vm.$set(_vm.searchForm, "shopName", $$v)
                      },
                      expression: "searchForm.shopName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.search()
                        }
                      }
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: {
                        click: function($event) {
                          return _vm.reset()
                        }
                      }
                    },
                    [_vm._v("重置")]
                  ),
                  _vm.$hasMethod("#export")
                    ? _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "warning" },
                          on: {
                            click: function($event) {
                              return _vm.exportFile()
                            }
                          }
                        },
                        [_vm._v("导出")]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("el-divider"),
      _c(
        "div",
        { staticClass: "child_page" },
        [
          _c(
            "div",
            { staticClass: "list_wrap" },
            [
              _vm._m(0),
              _vm._l(_vm.tableData, function(item) {
                return _c("div", { key: item.id, staticClass: "list_item" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex justify-between align-center item_header"
                    },
                    [
                      _c(
                        "el-tag",
                        {
                          attrs: { type: _vm.getOrderStatusType(item.status) }
                        },
                        [_vm._v(_vm._s(item.statusName))]
                      ),
                      _c("div", { staticClass: "flex-1 flex align-center" }, [
                        _c(
                          "span",
                          {
                            staticClass: "blue-font pointer",
                            on: {
                              click: function($event) {
                                _vm.$func.openBlank(
                                  _vm.$router.resolve({
                                    path: "/supplier/view/" + item.shopid
                                  })
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(item.shopname) +
                                "(" +
                                _vm._s(item.shopmobile) +
                                ")"
                            )
                          ]
                        ),
                        _c("p", [_vm._v("ID：" + _vm._s(item.id))]),
                        _c("p", [
                          _vm._v("创建时间：" + _vm._s(item.create_time))
                        ]),
                        _c("p", [_vm._v("订单号：" + _vm._s(item.trade_no))]),
                        _c("p", [_vm._v("供应商：" + _vm._s(item.shopname))]),
                        _c("p", [_vm._v("订单来源：" + _vm._s(item.source))]),
                        _c("p", [
                          _vm._v("快递信息：\n                "),
                          _c(
                            "span",
                            {
                              staticClass: "blue-font pointer",
                              on: {
                                click: function($event) {
                                  return _vm.checkLogistics(item.id)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    item.logistic.delivery_type == 2
                                      ? "上门自取"
                                      : item.logistic.delivery_type == 3
                                      ? "上门安装"
                                      : item.logistic.logistics_no
                                      ? item.logistic.logistics_no +
                                        "(" +
                                        item.logistic.logistics_name +
                                        ")"
                                      : "无"
                                  ) +
                                  "\n                "
                              )
                            ]
                          )
                        ])
                      ]),
                      _c("p")
                    ],
                    1
                  ),
                  _c("div", { staticClass: "flex item_row" }, [
                    _c(
                      "div",
                      { staticClass: "flex", staticStyle: { width: "27%" } },
                      [
                        _c(
                          "el-image",
                          {
                            staticStyle: { width: "100px", height: "100px" },
                            attrs: {
                              src: item.imgurl
                                ? _vm.$globalObj.imgBaseUrl + item.imgurl
                                : ""
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "image-slot",
                                attrs: { slot: "error" },
                                slot: "error"
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-picture-outline"
                                })
                              ]
                            )
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "flex-1",
                            staticStyle: {
                              "padding-left": "10px",
                              overflow: "hidden"
                            }
                          },
                          [
                            _c(
                              "p",
                              { staticClass: "text-ellipsis title blue-font" },
                              [_vm._v(_vm._s(item.goods_title))]
                            ),
                            _c("p", { staticClass: "meal" }, [
                              _vm._v("套餐信息：" + _vm._s(item.setmeal_title))
                            ]),
                            _c(
                              "p",
                              { staticClass: "device" },
                              [
                                _vm._v(
                                  "设备编号：" +
                                    _vm._s(item.device_number) +
                                    "\n                  "
                                ),
                                _vm.$hasMethod("#editDevice")
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "border-btn",
                                        staticStyle: { "margin-left": "5px" },
                                        attrs: { size: "mini" },
                                        on: {
                                          click: function($event) {
                                            return _vm.editDevice(item)
                                          }
                                        }
                                      },
                                      [_vm._v("更改")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "flex flex-center color-666 font-16",
                        staticStyle: { width: "3%" }
                      },
                      [_vm._v("x" + _vm._s(item.amount))]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "flex flex-column flex-center",
                        staticStyle: { width: "10%" }
                      },
                      [
                        _c("p", { staticClass: "red-font" }, [
                          _vm._v(
                            "￥" +
                              _vm._s(item.rent_total) +
                              "(共" +
                              _vm._s(item.month_total) +
                              "期)"
                          )
                        ]),
                        _c(
                          "p",
                          { staticStyle: { "margin-top": "10px" } },
                          [
                            _vm.$hasMethod("#checkLease")
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "border-btn",
                                    attrs: { size: "mini" },
                                    on: {
                                      click: function($event) {
                                        return _vm.viewLease(item.id)
                                      }
                                    }
                                  },
                                  [_vm._v("查看租期")]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "color-666 font-12 flex flex-center",
                        staticStyle: { width: "9%" }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(item.begin_time) +
                            "至" +
                            _vm._s(item.end_time) +
                            "(共" +
                            _vm._s(item.month_total) +
                            "期)\n            "
                        )
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "flex flex-column flex-center",
                        staticStyle: { width: "8%" }
                      },
                      [
                        item.rights_auth_no
                          ? _c("p", { staticClass: "red-font" }, [
                              _vm._v("￥" + _vm._s(item.foregift))
                            ])
                          : _vm._e(),
                        _c("p", { staticClass: "color-999 font-12" }, [
                          _vm._v(
                            _vm._s(
                              !item.rights_auth_no
                                ? "未授权免押"
                                : item.foregift_deduct == 0
                                ? "押金冻结"
                                : item.foregift > 0
                                ? "部分免押"
                                : "押金全免"
                            )
                          )
                        ]),
                        item.foregift_deduct > 0
                          ? _c(
                              "p",
                              {
                                staticClass: "color-999 font-12",
                                staticStyle: {
                                  "text-decoration": "line-through"
                                }
                              },
                              [
                                _vm._v(
                                  "￥" +
                                    _vm._s(
                                      parseFloat(item.foregift) +
                                        parseFloat(item.foregift_deduct)
                                    )
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "flex flex-column flex-center",
                        staticStyle: { width: "15%" }
                      },
                      [
                        _c("p", { staticClass: "red-font" }, [
                          _vm._v("￥" + _vm._s(item.lease.paid_rent))
                        ]),
                        _c("p", { staticClass: "color-999 font-12" }, [
                          _vm._v(
                            _vm._s(
                              item.pay_type == 1
                                ? "智能合同代扣"
                                : item.pay_type == 2
                                ? "芝麻信用（" +
                                  (item.rights_auth_no
                                    ? "已授权代扣"
                                    : "未授权代扣") +
                                  "）"
                                : "花呗"
                            )
                          )
                        ]),
                        _c(
                          "p",
                          { staticStyle: { "margin-top": "5px" } },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "long-text-btn",
                                attrs: { size: "mini", type: "success" },
                                on: {
                                  click: function($event) {
                                    return _vm.checkPaidBill(
                                      item.id,
                                      item.lease.paid_rent
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "已付：￥" +
                                    _vm._s(item.lease.paid_rent) +
                                    "/￥" +
                                    _vm._s(item.rent_total)
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "p",
                          { staticStyle: { "margin-top": "5px" } },
                          [
                            _c(
                              "el-button",
                              { attrs: { size: "mini", type: "warning" } },
                              [
                                _vm._v(
                                  "已结租金￥" +
                                    _vm._s(item.lease.settle_amount)
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "flex flex-center font-12 color-666",
                        staticStyle: { width: "5%" }
                      },
                      [
                        _vm._v(
                          _vm._s(item.is_buy_out == 1 ? "可买断" : "不可买断")
                        )
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "flex flex-column flex-center",
                        staticStyle: { width: "7%" }
                      },
                      [
                        JSON.stringify(item.lease.next) !== "[]"
                          ? [
                              _c("p", { staticClass: "font-12 color-666" }, [
                                _vm._v("￥" + _vm._s(item.lease.next.amount))
                              ]),
                              _c("p", { staticClass: "font-12 color-666" }, [
                                _vm._v(_vm._s(item.lease.next.date))
                              ])
                            ]
                          : _vm._e()
                      ],
                      2
                    ),
                    _c("div", { staticStyle: { width: "16%" } }, [
                      _c(
                        "p",
                        {
                          staticClass:
                            "flex align-center justify-between font-12 color-666"
                        },
                        [
                          _c("span", [_vm._v(_vm._s(item.realname))]),
                          _c("span", [_vm._v(_vm._s(item.address_mobile))])
                        ]
                      ),
                      _c(
                        "p",
                        {
                          staticClass: "font-12 color-666",
                          staticStyle: { "word-break": "break-all" }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              item.prov + item.city + item.area + item.address
                            )
                          )
                        ]
                      ),
                      _c(
                        "p",
                        { staticStyle: { "margin-top": "10px" } },
                        [
                          _vm.$hasMethod("#editAddress")
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "border-btn",
                                  attrs: { size: "mini" },
                                  on: {
                                    click: function($event) {
                                      return _vm.editAddress(item)
                                    }
                                  }
                                },
                                [_vm._v("修改地址")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "flex item_row" }, [
                    _c(
                      "div",
                      { staticClass: "detail", staticStyle: { width: "57%" } },
                      [
                        _c(
                          "p",
                          { staticClass: "color-666" },
                          [
                            _vm._v(
                              "认证资料：" +
                                _vm._s(item.cert_name) +
                                "（" +
                                _vm._s(item.cert_no) +
                                "）手机号：" +
                                _vm._s(item.mobile) +
                                "，人脸识别" +
                                _vm._s(
                                  item.authentic.status == 1 ? "通过" : "不通过"
                                ) +
                                " 性别：" +
                                _vm._s(item.authentic.sex) +
                                " 年龄：" +
                                _vm._s(item.authentic.age) +
                                "\n                "
                            ),
                            item.idcard_back &&
                            item.idcard_front &&
                            _vm.$hasMethod("#checkAuthInfo")
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "border-btn",
                                    attrs: { size: "mini" },
                                    on: {
                                      click: function($event) {
                                        return _vm.checkAuthInfo(item)
                                      }
                                    }
                                  },
                                  [_vm._v("认证资料")]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _c(
                          "p",
                          {
                            staticClass: "color-666",
                            class: { "red-font": item.is_skip == 1 }
                          },
                          [
                            _vm._v(
                              "\n                风控信息：" +
                                _vm._s(
                                  item.is_skip == 1
                                    ? "【未风控】商家跳过风控"
                                    : item.risk
                                ) +
                                "\n              "
                            )
                          ]
                        ),
                        _c("p", { staticClass: "color-666 font-12" }, [
                          _vm._v("用户备注：" + _vm._s(item.remark))
                        ]),
                        _c(
                          "p",
                          { staticClass: "color-666 font-12" },
                          [
                            _vm._v("客服备注：\n                "),
                            JSON.stringify(item.orderRemark) !== "[]"
                              ? [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(item.orderRemark.create_time) +
                                      "，" +
                                      _vm._s(item.orderRemark.username) +
                                      "添加备注：" +
                                      _vm._s(item.orderRemark.remark) +
                                      "\n                  "
                                  ),
                                  _vm.$hasMethod("#checkRemark")
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "blue-font pointer",
                                          staticStyle: {
                                            "margin-right": "10px"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.viewRemark(item.id)
                                            }
                                          }
                                        },
                                        [_vm._v("查看备注记录")]
                                      )
                                    : _vm._e()
                                ]
                              : _vm._e(),
                            _vm.$hasMethod("#addRemark")
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "border-btn",
                                    attrs: { size: "mini" },
                                    on: {
                                      click: function($event) {
                                        return _vm.addRemark(item.id)
                                      }
                                    }
                                  },
                                  [_vm._v("添加备注")]
                                )
                              : _vm._e()
                          ],
                          2
                        ),
                        _c(
                          "p",
                          {
                            staticClass: "color-666",
                            staticStyle: { "margin-top": "5px" }
                          },
                          [
                            JSON.stringify(item.leaseFlow) !== "[]"
                              ? [
                                  _vm._v(
                                    "\n                  第" +
                                      _vm._s(item.leaseFlow.which_period) +
                                      "期通过支付宝" +
                                      _vm._s(
                                        item.leaseFlow.pay_type == 1
                                          ? "智能合同代扣"
                                          : item.leaseFlow.pay_type == 2
                                          ? "芝麻信用"
                                          : item.leaseFlow.pay_type == 3
                                          ? "花呗"
                                          : "主动支付"
                                      ) +
                                      _vm._s(
                                        item.leaseFlow.status == 1
                                          ? "支付" + item.leaseFlow.rent + "元"
                                          : item.leaseFlow.status == 2
                                          ? "退款" + item.leaseFlow.rent + "元"
                                          : item.leaseFlow.status == 3
                                          ? "买断"
                                          : "未支付"
                                      ) +
                                      "\n                "
                                  )
                                ]
                              : _vm._e(),
                            _vm.$hasMethod("#checkFlow")
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "border-btn",
                                    attrs: { size: "mini" },
                                    on: {
                                      click: function($event) {
                                        return _vm.viewFlow(item.trade_no)
                                      }
                                    }
                                  },
                                  [_vm._v("流水记录")]
                                )
                              : _vm._e()
                          ],
                          2
                        )
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "flex flex-column justify-center",
                        staticStyle: { width: "43%" }
                      },
                      [
                        item.orderRefundReason
                          ? _c("p", { staticStyle: { padding: "0 10px" } }, [
                              _vm._v(
                                "退款原因：" + _vm._s(item.orderRefundReason)
                              )
                            ])
                          : _vm._e(),
                        _c(
                          "p",
                          { staticClass: "btns flex align-center" },
                          [
                            item.status == 10 && _vm.$hasMethod("#delivery")
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "warning" },
                                    on: {
                                      click: function($event) {
                                        return _vm.openDelivery(item.id)
                                      }
                                    }
                                  },
                                  [_vm._v("订单发货")]
                                )
                              : _vm._e(),
                            item.status == 20 && _vm.$hasMethod("#receipt")
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "warning" },
                                    on: {
                                      click: function($event) {
                                        return _vm.confirmReceipt(item.id)
                                      }
                                    }
                                  },
                                  [_vm._v("确认收货")]
                                )
                              : _vm._e(),
                            item.status == 44
                              ? _c(
                                  "el-button",
                                  { attrs: { size: "mini", type: "warning" } },
                                  [_vm._v("确认归还")]
                                )
                              : _vm._e(),
                            item.status == 45
                              ? _c(
                                  "el-button",
                                  { attrs: { size: "mini", type: "warning" } },
                                  [_vm._v("归还完成")]
                                )
                              : _vm._e(),
                            [
                              20,
                              30,
                              40,
                              44,
                              45,
                              60,
                              61,
                              62,
                              11,
                              12,
                              13,
                              14,
                              15,
                              16
                            ].indexOf(item.status) > -1 &&
                            _vm.$hasMethod("#checkLogistics")
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.checkLogistics(item.id)
                                      }
                                    }
                                  },
                                  [_vm._v("查看物流")]
                                )
                              : _vm._e(),
                            [
                              3,
                              10,
                              20,
                              30,
                              39,
                              40,
                              44,
                              45,
                              60,
                              61,
                              62,
                              11,
                              12,
                              13,
                              14,
                              15,
                              16
                            ].indexOf(item.status) > -1 && item.pact_url != 0
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.checkPact(
                                          _vm.$globalObj.imgBaseUrl +
                                            item.pact_url
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("查看合同")]
                                )
                              : _vm._e(),
                            [11, 12, 13, 14].indexOf(item.status) > -1
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "warning" },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleRefundOrder(
                                          item.trade_no
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("去处理")]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ])
              })
            ],
            2
          ),
          _c("custom-page", {
            ref: "customPage",
            attrs: { total: _vm.total },
            on: { getList: _vm.getList }
          })
        ],
        1
      ),
      _c("check-lease", {
        ref: "checkLease",
        attrs: { "order-id": _vm.selectedId }
      }),
      _c("set-address", {
        ref: "setAddress",
        attrs: { "edit-item": _vm.editItem },
        on: { getList: _vm.getList }
      }),
      _c("set-device", {
        ref: "setDevice",
        attrs: { "edit-item": _vm.editItem },
        on: { getList: _vm.getList }
      }),
      _c("set-remark", {
        ref: "setRemark",
        attrs: { "order-id": _vm.selectedId },
        on: { getList: _vm.getList }
      }),
      _c("check-remark", {
        ref: "checkRemark",
        attrs: { "order-id": _vm.selectedId }
      }),
      _c("check-flow", {
        ref: "checkFlow",
        attrs: { "order-no": _vm.selectedId }
      }),
      _c("delivery", {
        ref: "delivery",
        attrs: { "order-id": _vm.selectedId },
        on: { getList: _vm.getList }
      }),
      _c("receipt", {
        ref: "receipt",
        attrs: { "order-id": _vm.selectedId },
        on: { getList: _vm.getList }
      }),
      _c("auth-info", {
        ref: "authInfo",
        attrs: { "edit-item": _vm.editItem }
      }),
      _c("check-bill", {
        ref: "checkBill",
        attrs: { "order-id": _vm.selectedId }
      }),
      _c("check-logistics", {
        ref: "checkLogistics",
        attrs: { "order-id": _vm.selectedId }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex list_header" }, [
      _c("p", { staticStyle: { width: "27%", "padding-left": "20px" } }, [
        _vm._v("商品信息")
      ]),
      _c("p", { staticClass: "text-center", staticStyle: { width: "3%" } }, [
        _vm._v("数量")
      ]),
      _c("p", { staticClass: "text-center", staticStyle: { width: "10%" } }, [
        _vm._v("租金")
      ]),
      _c("p", { staticClass: "text-center", staticStyle: { width: "9%" } }, [
        _vm._v("租期")
      ]),
      _c("p", { staticClass: "text-center", staticStyle: { width: "8%" } }, [
        _vm._v("押金")
      ]),
      _c("p", { staticClass: "text-center", staticStyle: { width: "15%" } }, [
        _vm._v("实付金额")
      ]),
      _c("p", { staticClass: "text-center", staticStyle: { width: "5%" } }, [
        _vm._v("是否买断")
      ]),
      _c("p", { staticClass: "text-center", staticStyle: { width: "7%" } }, [
        _vm._v("下期付款金额")
      ]),
      _c("p", { staticStyle: { width: "16%", "padding-left": "20px" } }, [
        _vm._v("收货人信息")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }